import React from 'react';
import { inrCompact } from '../poPayment';

const slug = (s) => String(s).replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();

const Tags = ({ items, tone }) => (
  <div className="flex flex-wrap gap-1">
    {items.slice(0, 3).map((x) => <span key={x} className={`px-1.5 py-0.5 rounded-md text-[10px] font-medium border truncate max-w-[120px] ${tone}`} title={x}>{x}</span>)}
    {items.length > 3 && <span className="text-[10px] text-slate-500 self-center" title={items.slice(3).join(', ')}>+{items.length - 3}</span>}
  </div>
);

export default function POVendorTable({ vendors, onDrill }) {
  const rows = vendors || [];
  return (
    <div className="soft-card p-4 sm:p-5" data-testid="po-vendor-table">
      <h3 className="font-semibold text-[#1a1a2e]">Vendors</h3>
      <p className="text-xs text-slate-500 mb-3">Who you buy from, and for which clients and categories</p>
      <div className="overflow-x-auto max-h-[420px] overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-white">
            <tr className="text-[11px] uppercase tracking-wider text-slate-500">
              <th className="text-left font-semibold py-2 pr-2">Vendor</th>
              <th className="text-right font-semibold py-2 px-2">POs</th>
              <th className="text-right font-semibold py-2 px-2">Value</th>
              <th className="text-left font-semibold py-2 px-2">Clients</th>
              <th className="text-left font-semibold py-2 pl-2">Categories</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.length === 0 && <tr><td colSpan={5} className="py-6 text-center text-slate-500">No vendors</td></tr>}
            {rows.map((v) => (
              <tr key={v.key} onClick={() => onDrill({ vendor: v.key, title: v.label })} className="cursor-pointer hover:bg-fuchsia-50/50 transition-colors" data-testid={`po-vendor-row-${slug(v.key)}`}>
                <td className="py-2 pr-2">
                  <p className="font-medium text-[#1a1a2e] truncate max-w-[180px]" title={v.label}>{v.label}</p>
                  <div className="h-1 rounded-full bg-slate-100 mt-1 w-28"><div className="h-1 rounded-full bg-fuchsia-500" style={{ width: `${v.share}%` }} /></div>
                </td>
                <td className="py-2 px-2 text-right tabular-nums text-slate-600">{v.count}</td>
                <td className="py-2 px-2 text-right tabular-nums font-semibold text-[#1a1a2e] whitespace-nowrap">{inrCompact(v.total)}</td>
                <td className="py-2 px-2"><Tags items={v.clients} tone="bg-sky-50 text-sky-700 border-sky-100" /></td>
                <td className="py-2 pl-2"><Tags items={v.categories} tone="bg-fuchsia-50 text-fuchsia-700 border-fuchsia-100" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
